import { render, staticRenderFns } from "./wdBalance.vue?vue&type=template&id=d9ed15cc&scoped=true&"
import script from "./wdBalance.vue?vue&type=script&lang=js&"
export * from "./wdBalance.vue?vue&type=script&lang=js&"
import style0 from "./wdBalance.vue?vue&type=style&index=0&id=d9ed15cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ed15cc",
  null
  
)

export default component.exports